const caldercrystals = function(){

    const init = function(){
        ready(() => {
            //categoryTitles();
            initCalendly();
            initWhatsAppLink();
        });
    };

    // helper document ready function
    const ready = function(fnc){
        if(document.readyState !== 'loading'){
            fnc();
        }else{
            document.addEventListener("DOMContentLoaded", fnc); 
        }
    };

    // Calendly ================
    const initCalendly = function(){
        const _calendlyTarget = 'https://calendly.com/caldercrystals-info/30min';
        //Calendly.initBadgeWidget({ url: _calendlyTarget, text: 'Book An Appointment', color: '#0069ff', textColor: '#ffffff', branding: true });
        const calendlyLaunchers = document.getElementsByClassName("calendly-launch");
        for (let el of calendlyLaunchers) {
            el.addEventListener("click", function(e){
                e.preventDefault();
                Calendly.initPopupWidget({url: _calendlyTarget});
            });
        }
    };

    // WhatsApp link ===========
    const initWhatsAppLink = function(){
        //const _whatsappTarget = 'https://web.whatsapp.com/send?phone=447375630603&text=';
        const _whatsappTarget = 'https://wa.me/447375630603?text=';
        window.onload = function(){
            document.body.insertAdjacentHTML('beforeend', '<a href="' + _whatsappTarget + '" target="_blank" class="whatsapp-badge whatsapp"><img src="https://cdn.shopify.com/s/files/1/1004/6062/6184/files/icon-whatsapp-with-label.svg?v=1788423019" width="104" height="24" alt="WhatsApp"></a>');
        };
    };

    // modify category titles (NOT IN USE) ===========
    const categoryTitles = function(){
        const crumbs = document.querySelectorAll(".cc-breadcrumbs-link,.collection-hero__title,.card__heading a");
        crumbs.forEach((crumb) => {
            crumb.childNodes.forEach(node => {
                if (node.nodeType === Node.TEXT_NODE) { // Only direct text nodes
                    let title = node.textContent;
                    const splitTitle = title.split(">");
                    node.textContent = splitTitle[splitTitle.length-1];
                }
            });            
        });
    };

    init();
}();